// localStorage helper functions for country and language
const STORAGE_KEYS = {
  COUNTRY: 'selectedCountry',
  LANGUAGE: 'selectedLanguage',
  LANGUAGE_MANUAL: 'languageManuallySelected',
  GEO_PERMISSION: 'lastGeolocationPermission',
};

export const localStorageHelper = {
  getCountry: () => {
    try {
      return localStorage.getItem(STORAGE_KEYS.COUNTRY);
    } catch (error) {
      console.error('Error getting country from localStorage:', error);
      return null;
    }
  },

  setCountry: (country) => {
    try {
      if (country) {
        localStorage.setItem(STORAGE_KEYS.COUNTRY, country);
      } else {
        localStorage.removeItem(STORAGE_KEYS.COUNTRY);
      }
    } catch (error) {
      console.error('Error setting country to localStorage:', error);
    }
  },

  getLanguage: () => {
    try {
      return localStorage.getItem(STORAGE_KEYS.LANGUAGE);
    } catch (error) {
      console.error('Error getting language from localStorage:', error);
      return null;
    }
  },

  setLanguage: (language) => {
    try {
      if (language) {
        localStorage.setItem(STORAGE_KEYS.LANGUAGE, language);
      } else {
        localStorage.removeItem(STORAGE_KEYS.LANGUAGE);
      }
    } catch (error) {
      console.error('Error setting language to localStorage:', error);
    }
  },

  isLanguageManuallySelected: () => {
    try {
      return localStorage.getItem(STORAGE_KEYS.LANGUAGE_MANUAL) === 'true';
    } catch (error) {
      return false;
    }
  },

  setLanguageManuallySelected: (isManual = true) => {
    try {
      if (isManual) {
        localStorage.setItem(STORAGE_KEYS.LANGUAGE_MANUAL, 'true');
      } else {
        localStorage.removeItem(STORAGE_KEYS.LANGUAGE_MANUAL);
      }
    } catch (error) {
      console.error('Error setting language manual flag:', error);
    }
  },

  getLastGeolocationPermission: () => {
    try {
      return localStorage.getItem(STORAGE_KEYS.GEO_PERMISSION);
    } catch (error) {
      return null;
    }
  },

  setLastGeolocationPermission: (state) => {
    try {
      if (state) {
        localStorage.setItem(STORAGE_KEYS.GEO_PERMISSION, state);
      } else {
        localStorage.removeItem(STORAGE_KEYS.GEO_PERMISSION);
      }
    } catch (error) {
      console.error('Error setting geolocation permission state:', error);
    }
  },

  clear: () => {
    try {
      localStorage.removeItem(STORAGE_KEYS.COUNTRY);
      localStorage.removeItem(STORAGE_KEYS.LANGUAGE);
      localStorage.removeItem(STORAGE_KEYS.LANGUAGE_MANUAL);
      localStorage.removeItem(STORAGE_KEYS.GEO_PERMISSION);
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  },
};
